import api from "@/lib/api";

export async function fetchPlatformEmailOauth() {
  const { data } = await api.get("/system/platform-email-oauth");
  return data;
}

export async function savePlatformEmailOauth(body) {
  const { data } = await api.put("/system/platform-email-oauth", body);
  return data;
}
